import aframe from "aframe";

aframe.registerComponent("smart-missile-times", {
  schema: {
    times: { type: "array" },
    speed: { type: "number", default: 0.1 },
    steerSpeed: { type: "number", default: Math.PI }
  },
  play() {
    if (!this.started) {
      this.el.components["wave-queue"].registerGenerator(this.iter());
      this.prevTime = 0;
      this.timer = 0;
      this.started = true;
    }
  },
  tick(t, dt) {
    this.timer += dt;
  },
  *iter() {
    let prevTime = this.timer;
    while (true) {
      if (
        !this.data.times.length ||
        this.data.times[this.data.times.length - 1] < prevTime
      ) {
        break;
      }

      const waves = [];

      for (let i = 0; i < this.data.times.length; i++) {
        const spawnTime = this.data.times[i];
        if (prevTime <= spawnTime && this.timer > spawnTime) {
          waves.push(this.smartMissile());
        }
      }

      prevTime = this.timer;
      yield waves;
    }

    yield "done";
  },
  smartMissile() {
    return {
      type: "smart-missile",
      data: {
        speed: this.data.speed,
        steerSpeed: this.data.steerSpeed
      }
    };
  }
});
